import { useQuery, UseQueryResult } from '@taxdown/zeno-sama-query';
import RecordsService from 'Services/records';
import SatService from 'Services/sat';
import { SatResponseType } from 'Services/sat/types';
import { store } from 'Store';
import { taxSelectedSelector } from 'Store/modules/tax/selectors';
import { ResponseType, SubmitInfoFilingType } from 'Types/common';
import { AccountQueryKey } from './types';

const getUserDataSelector = (data: ResponseType<SatResponseType>): SatResponseType => {
  const userData = data.data;
  return userData.item;
};

export const useFetchSatUserData = (): UseQueryResult<SatResponseType> =>
  useQuery(
    [AccountQueryKey.FETCH_SAT_USER_DATA],
    (): Promise<ResponseType<SatResponseType>> =>
      SatService.getSatUser({ password: true, efirma: true }),
    {
      select: data => getUserDataSelector(data),
      onSuccess: data => {
        return data;
      },
      refetchOnWindowFocus: false,
      cacheTime: 0,
    }
  );

export const useFetchGetUserClabe = (): UseQueryResult<SubmitInfoFilingType> => {
  const { recordId } = taxSelectedSelector(store.getState()) ?? {};
  return useQuery([AccountQueryKey.GET_CLABE], () => RecordsService.getFiledInfo(), {
    select: data => {
      const response = data.data;
      return response.item;
    },
    refetchOnWindowFocus: false,
    enabled: recordId !== undefined,
    cacheTime: 0,
  });
};
